import { configureStore } from '@reduxjs/toolkit';
import seoReducer from "../redux/seoSlice";
import blogsReducer from '../redux/blogsSlice';
import galleryReducer from '../redux/gallerySlice';
import testimonialsReducer from '../redux/testimonialSlice';
import categoriesReducer from "../redux/categoriesSlice";
import productsReducer from "../redux/productsSlice";
import treatmentReducer from "../redux/treatmentSlice";
import feedbackReducer from '../redux/feedbackSlice';
import organizationReducer from '../redux/organizationSlice';
import faqReducer from '../redux/faqSlice';


export const setupStore = (preloadedState) => {
  return configureStore({
    reducer: {
      seo: seoReducer,
      blogs: blogsReducer,
      gallery: galleryReducer,
      testimonials: testimonialsReducer,
      categories: categoriesReducer,
      organization: organizationReducer,
      products: productsReducer,
      treatment: treatmentReducer,
      feedbacks: feedbackReducer,
      faq:faqReducer
    },
    preloadedState,
  });
};

const store = setupStore();
export default store;
